import { render } from "./LoyaltyStep.vue?vue&type=template&id=39ded91a&scoped=true"
import script from "./LoyaltyStep.vue?vue&type=script&lang=js"
export * from "./LoyaltyStep.vue?vue&type=script&lang=js"

import "./LoyaltyStep.vue?vue&type=style&index=0&id=39ded91a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ded91a"]])

export default __exports__